import { Component, input, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';

interface DoubleSetting {
    value: number;
    minValue?: string;
    maxValue?: string;
    label: string;
    helptext?: string;
    required: boolean;
    readonly: boolean;
    name: string;
}

@Component( {
    selector: 'his-double-job-setting',
    templateUrl: './his-double-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
} )
export class HisDoubleJobSettingComponent {
    setting = input.required<DoubleSetting>();
    protected minValue = computed( () => this.asNumber( this.setting().minValue ) );
    protected maxValue = computed( () => this.asNumber( this.setting().maxValue ) );
    private baseGlobalService = inject( HisBaseGlobalsService );
    
    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    } );
    
    private asNumber( value: string | number ): number | undefined {
        if ( typeof value === 'number' && !isNaN( value ) ) {
            return value;
        }

        if ( !value ) {
            return undefined;
        }

        const returnValue = +value;
        if ( isNaN( returnValue ) ) {
            return undefined;
        }
        return returnValue;
    }
}
